// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"90b64eaa","455":"9eb034d7","977":"aea9b396"}[chunkId] + ".chunk.js";
};